var _a, _b, _c;
import { createUseStyles } from "react-jss";
var portal = "#222222";
var laser = "#FF3158";
var moonrock = "#F5F4F3";
// Need to declare props here to handle types
export var useButtonStyles = createUseStyles({
    buttonBase: {
        alignContent: "baseline",
        alignItems: "inherit",
        borderRadius: "6px",
        cursor: "pointer",
        flexDirection: "row",
        fontFamily: '"IBM Plex Sans","Helvetica Neue",Helvetica,Arial,sans-serif',
        fontSize: "16px",
        fontWeight: 700,
        height: function (_a) {
            var thin = _a.thin;
            return (thin ? "34px" : "48px");
        },
        justifyContent: "center",
        letterSpacing: "0.2px",
        lineHeight: "16px",
        minHeight: "34px",
        minWidth: "100px",
        outline: 0,
        padding: function (_a) {
            var thin = _a.thin;
            return (thin ? "0 10px" : "10px");
        },
        textAlign: "center",
        textDecoration: "none",
        textTransform: "none",
        transition: "all 250ms ease-out",
        width: "auto",
        "&:focus-visible": {
            outline: "1px auto Highlight",
        },
    },
    buttonPrimary: (_a = {
            borderColor: "transparent",
            "&:disabled": {
                cursor: "inherit",
                opacity: 0.3,
            },
            "&:hover:not([disabled])": {
                backgroundColor: laser,
                borderColor: "transparent",
                color: moonrock,
            }
        },
        _a["@media (prefers-color-scheme: light)"] = {
            backgroundColor: function (_a) {
                var light = _a.light;
                return (light ? moonrock : portal);
            },
            color: function (_a) {
                var light = _a.light;
                return (light ? portal : moonrock);
            },
        },
        _a["@media (prefers-color-scheme: dark)"] = {
            backgroundColor: function (_a) {
                var dark = _a.dark;
                return (dark ? portal : moonrock);
            },
            color: function (_a) {
                var dark = _a.dark;
                return (dark ? moonrock : portal);
            },
        },
        _a),
    buttonSecondary: (_b = {
            backgroundColor: "transparent",
            "&:disabled": {
                cursor: "inherit",
                opacity: 0.3,
            },
            "&:hover:not([disabled])": {
                borderColor: laser,
                color: laser,
            }
        },
        _b["@media (prefers-color-scheme: light)"] = {
            color: function (_a) {
                var light = _a.light;
                return (light ? moonrock : portal);
            },
            border: function (_a) {
                var light = _a.light;
                return light ? "2px solid ".concat(moonrock) : "2px solid ".concat(portal);
            },
        },
        _b["@media (prefers-color-scheme: dark)"] = {
            color: function (_a) {
                var dark = _a.dark;
                return (dark ? portal : moonrock);
            },
            border: function (_a) {
                var dark = _a.dark;
                return dark ? "2px solid ".concat(portal) : "2px solid ".concat(moonrock);
            },
        },
        _b),
    buttonTertiary: (_c = {
            background: "none",
            border: "none",
            fontFamily: '"Roboto","Helvetica Neue",Helvetica,Arial,sans-serif',
            fontSize: 14,
            letterSpacing: "0.6px",
            lineHeight: "26px",
            minHeight: "auto",
            minWidth: "auto",
            padding: 0,
            textTransform: "none",
            width: "auto",
            "&:hover:not([disabled])": {
                color: laser,
                "& span": {
                    borderBottomColor: laser,
                },
            },
            "& span": {
                transition: "border 250ms ease-out",
            }
        },
        _c["@media (prefers-color-scheme: light)"] = {
            color: function (_a) {
                var light = _a.light;
                return (light ? moonrock : portal);
            },
            "& span": {
                borderBottom: function (_a) {
                    var light = _a.light;
                    return light ? "2px solid ".concat(moonrock) : "2px solid ".concat(portal);
                },
            },
            "&:disabled": {
                cursor: "inherit",
                opacity: 0.3,
                "& span": {
                    opacity: 0.3,
                },
            },
        },
        _c["@media (prefers-color-scheme: dark)"] = {
            color: function (_a) {
                var dark = _a.dark;
                return (dark ? portal : moonrock);
            },
            "& span": {
                borderBottom: function (_a) {
                    var dark = _a.dark;
                    return dark ? "2px solid ".concat(portal) : "2px solid ".concat(moonrock);
                },
            },
            "&:disabled": {
                opacity: 0.3,
                cursor: "inherit",
                "& span": {
                    opacity: 0.3,
                },
            },
        },
        _c),
    buttonLink: {
        padding: "0 !important",
        height: "auto !important",
        minHeight: 0,
        minWidth: 0,
        backgroundColor: "transparent",
        borderColor: "transparent",
        "&:disabled": {
            cursor: "inherit",
            opacity: 0.3,
        },
        "&:hover:not([disabled])": {
            backgroundColor: "transparent",
            borderColor: "transparent",
            color: laser,
            "&:myIcon": {
                fill: laser,
            },
        },
    },
    myLabel: {
        "font-weight": "bold",
        "align-items": "center",
        display: "inline-flex",
    },
    myIcon: {
        "margin-right": "12px",
    },
});
